module.exports = __webpack_public_path__ + "static/img/cs1.89fe0304.png";